import * as React from "react";
import { connect } from "react-redux";

import {
  AvailableGifts as AvailableGiftsComponent,
  AvailableGiftsProps,
} from "../../components/AvailableGifts/AvailableGifts";

class AvailableGifts extends React.Component<AvailableGiftsProps> {
  render() {
    return <AvailableGiftsComponent {...this.props} />;
  }
}

export default connect(null, {})(AvailableGifts);
